import FormTitle from '@core/components/FormTitle';
import { TextLabel } from '@core/components/Inputs';
import DateLabel from '@core/components/Inputs/DateLabel';
import {
  Grid,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@material-ui/core';
import moment from 'moment';
import React, { useState } from 'react';
import { FaCheck } from 'react-icons/fa';

const VisualizarVendaFormaPagamento = ({ venda, getCurrency, styles }) => {
  const [page, setPage] = useState(0);
  const rowsPerPage = 5;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const FORMA_RECEBIMENTO = {
    BOLETO: 'Boleto',
    PIX: 'Pix',
    CARTAO_DEBITO: 'Cartão de débito',
    CARTAO_CREDITO: 'Cartão de crédito',
    DINHEIRO: 'Dinheiro',
    TED_DOC: 'TED/DOC',
    CHEQUE: 'Cheque',
  };

  const TIPO_PAGAMENTO = {
    A_VISTA: 'À vista',
    PARCELADO: 'Parcelado',
  };

  return (
    <>
      <FormTitle title="Informações do pagamento" />
      <Grid container spacing={3} className="mb-16">
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <TextLabel
            id="formaRecebimento"
            label="Forma de recebimento"
            value={FORMA_RECEBIMENTO[venda?.pagamento?.formaRecebimento]}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
          <TextLabel
            id="tipoPagamento"
            label="Condição de pagamento"
            value={TIPO_PAGAMENTO[venda?.pagamento?.tipoPagamento]}
          />
        </Grid>
        {venda?.pagamento?.tipoPagamento === 'A_VISTA' ? (
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
            <DateLabel
              id="dataVencimento"
              label="Data do vencimento"
              value={venda?.pagamento?.avista?.dataVencimento}
            />
          </Grid>
        ) : (
          <>
            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
              <TextLabel
                id="quantidade"
                label="Quantidade de parcelas"
                value={venda?.pagamento?.parcelamento?.parcelas?.length}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ paddingBottom: 0 }} className="mb-16">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Parcelas</TableCell>
                    <TableCell align="center">Data do vencimento</TableCell>
                    <TableCell align="right">Valor parcelado (R$)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {venda?.pagamento?.parcelamento?.parcelas
                    ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    ?.map((parcela) => {
                      return (
                        <TableRow>
                          <TableCell component="th" align="left">
                            {`Parcela ${parcela?.numParcela}`}
                          </TableCell>
                          <TableCell align="center">
                            {parcela?.dataVencimento ? moment(parcela?.dataVencimento).format('DD/MM/YYYY') : '-'}
                          </TableCell>
                          <TableCell align="right">{getCurrency(parcela?.valor)}</TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>

              {venda?.pagamento?.parcelamento?.parcelas?.length > 5 && (
                // RNE-214
                <TablePagination
                  component="div"
                  className="pb-0"
                  count={venda?.pagamento?.parcelamento?.parcelas?.length}
                  rowsPerPage={rowsPerPage}
                  labelRowsPerPage={false}
                  page={page}
                  labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                  onChangePage={handleChangePage}
                  rowsPerPageOptions={[]}
                />
              )}
            </Grid>
          </>
        )}

        {venda?.envioAutomaticoCobranca && (
          <Grid item xs={12} className={styles.iconText}>
            <Icon className={styles.icon}>
              <FaCheck size={14} />
            </Icon>
            <Typography id="envioAutomaticoCobranca">Envio automático de cobrança</Typography>
          </Grid>
        )}
        {venda?.enviarCobrancaEmail && (
          <Grid item xs={6} className={styles.iconText}>
            <Icon className={styles.icon}>
              <FaCheck size={14} />
            </Icon>
            <Typography id="enviarCobrancaEmail">Enviar cobrança por e-mail</Typography>
          </Grid>
        )}
        {venda?.enviarNotaFiscalEmail && (
          <Grid item xs={6} className={styles.iconText}>
            <Icon className={styles.icon}>
              <FaCheck size={14} />
            </Icon>
            <Typography id="enviarNotaFiscalEmail">Enviar Nota Fiscal por e-mail</Typography>
          </Grid>
        )}
        {venda?.emailsCliente?.length > 0 && (
          <Grid item xs={12}>
            <TextLabel
              id="0.emailPrincipal"
              label="E-mail principal do cliente"
              value={venda?.emailsCliente[0]?.email}
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <b>E-mails adicionais</b>
          {venda?.emailsCliente?.length > 1 ? (
            venda.emailsCliente.map((emailCliente, index) => {
              return index > 0 && <Typography id={`${index}.emailCliente`}>{emailCliente.email}</Typography>;
            })
          ) : (
            <Typography>-</Typography>
          )}
        </Grid>
        {venda?.faturarContratoVendaJuntos && (
          <Grid item xs={12} className={styles.iconText}>
            <Icon className={styles.icon}>
              <FaCheck size={14} />
            </Icon>
            <Typography id="faturarContratoVendaJuntos">Faturar a venda junto com o contrato</Typography>
          </Grid>
        )}
        {venda?.unificarCobrancaContratoVenda && (
          <Grid item xs={12} className={styles.iconText}>
            <Icon className={styles.icon}>
              <FaCheck size={14} />
            </Icon>
            <Typography id="unificarCobrancaContratoVenda">Unificar cobrança da venda com o contrato</Typography>
          </Grid>
        )}

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel
            id="informacoesComplementares"
            label="Informações complementares"
            value={venda?.informacoesComplementares}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default VisualizarVendaFormaPagamento;
